import React from 'react'

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton,
} from 'react-accessible-accordion'

import Paragraph from 'components/base/Paragraph'

import AccordionWrap from './styles'

const CompetitiveBenefits: React.FC = (): React.ReactElement => (
  <AccordionWrap>
    <Accordion allowMultipleExpanded={true} allowZeroExpanded={true}>
      <AccordionItem>
        <AccordionItemHeading>
          <AccordionItemButton>No Commission Sales</AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <Paragraph>
            Unlike the majority of other insurance agents and brokers,
            Insurance Lounge Insurance Concierges<sup>®</sup> are not paid
            based on a percentage of the premium of the policies they sell.
            Insurance Lounge has created a salary structure with bonus
            opportunities that incentivize Insurance Concierges to assist
            every client equally and recommend the coverages that best fit
            their needs.
          </Paragraph>
        </AccordionItemPanel>
      </AccordionItem>
      <AccordionItem>
        <AccordionItemHeading>
          <AccordionItemButton>Metallic Growth</AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <Paragraph>
            Insurance Lounge encourages employees to build their career with
            the company through a growth plan designed to reward achievement
            and longevity.
          </Paragraph>
        </AccordionItemPanel>
      </AccordionItem>
      <AccordionItem>
        <AccordionItemHeading>
          <AccordionItemButton>401(K) &amp; Health</AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <Paragraph>
            Insurance Lounge offers a competitive 401(k) contribution match
            as well as health insurance benefits.
          </Paragraph>
        </AccordionItemPanel>
      </AccordionItem>
    </Accordion>
  </AccordionWrap>
)

export default CompetitiveBenefits
